import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import DetailField from '../../../components/form/field/field';
import { styles } from '../task-detail-styles';

const PaInsuranceDetail = props => {
  const { classes } = props;
  const selectedTaskKeys = useSelector(state => state.tasks.selectedTaskKeys) || [];
  const [taskKey] = selectedTaskKeys;
  const tasks = useSelector(state => state.tasks.data) || [];

  const financials = useSelector(state => state.financials);
  const [currentInsurance, setCurrentInsurance] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);

  const [paInsurance, setPaInsurance] = useState({
    reference: '',
    authorization: '',
    name: '',
    binNumber: '',
    pcn: '',
    rxGroup: '',
  });

  useEffect(() => {
    const paTask = tasks[taskKey];
    setSelectedTask(paTask);
  }, [tasks, taskKey]);

  useMemo(() => {
    if (selectedTask != null) {
      if (selectedTask?.pbm_insurances !== undefined && selectedTask?.pbm_insurances !== '') {
        const insurances = Object.values(financials.pbm_insurances?.data) || [];
        const [insurance] = insurances.filter(i => i.id == selectedTask?.pbm_insurances);
        setCurrentInsurance(insurance);
      } else if (
        selectedTask?.medical_insurances !== undefined &&
        selectedTask?.medical_insurances !== ''
      ) {
        const insurances = Object.values(financials.medical_insurances?.data) || [];
        const [insurance] = insurances.filter(i => i.id == selectedTask?.medical_insurances);
        setCurrentInsurance(insurance);
      }
    }
  }, [financials, selectedTask]);

  useEffect(() => {
    if (currentInsurance) {
      setPaInsurance({
        binNumber: currentInsurance.pbm_bin_number,
        pcn: currentInsurance.pbm_processor_control_number,
        rxGroup: currentInsurance.pbm_rx_group_number,
        name: currentInsurance.pbm_name,
        reference: selectedTask.reference_number,
        authorization: selectedTask.auth_number,
      });
    }
  }, [currentInsurance]);

  return selectedTask?.is_renewal == 1 ? (
    <Grid container className={classes.boxContainer}>
      <Grid container className={classes.formRowContainer}>
        <Grid item xs={6} className={classes.fieldContainer}>
          <DetailField fieldName="Reference #" field={paInsurance.reference} variant="raw" />
        </Grid>
        <Grid item xs={6} className={classes.fieldContainer}>
          <DetailField fieldName="Authorization" field={paInsurance.authorization} />
        </Grid>
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <DetailField fieldName="Name" field={paInsurance.name} />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <DetailField fieldName="BIN Number" field={paInsurance.binNumber} />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <DetailField fieldName="PCN" field={paInsurance.pcn} />
      </Grid>
      <Grid item xs={3} className={classes.fieldContainer}>
        <DetailField fieldName="Rx Group Number" field={paInsurance.rxGroup} />
      </Grid>
    </Grid>
  ) : null;
};

export default withStyles(styles)(PaInsuranceDetail);
